export const ArrowRight = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <path d="M5 12h13M12 5l7 7-7 7" />
  </svg>
);

export const User = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const Settings = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="4" y1="21" x2="4" y2="14" />
    <line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" />
    <line x1="20" y1="12" x2="20" y2="3" />
    <line x1="1" y1="14" x2="7" y2="14" />
    <line x1="9" y1="8" x2="15" y2="8" />
    <line x1="17" y1="16" x2="23" y2="16" />
  </svg>
);

export const Time = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

export const Plus = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const Minus = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const ChefHat = ({ size = 18, className = "", fill = "white"}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.5943 5.88002C16.2257 5.88002 15.8571 5.94002 15.5229 6.0343C15.06 4.5343 13.6543 3.42859 12 3.42859C10.3457 3.42859 8.94 4.5343 8.47714 6.0343C8.14286 5.94002 7.77429 5.88002 7.40572 5.88002C5.20286 5.88002 3.42857 7.6543 3.42857 9.85716C3.42857 11.5114 4.44 12.9172 5.88 13.5343V18.5829C6.09429 20.1429 9.77143 20.5714 12 20.5714C14.2286 20.5714 17.9057 20.1429 18.12 18.5829V13.5343C19.56 12.9257 20.5714 11.5114 20.5714 9.85716C20.5714 7.6543 18.7971 5.88002 16.5943 5.88002ZM12 19.3457C9.09429 19.3457 7.46572 18.7372 7.13143 18.4286C7.46572 18.12 9.09429 17.5114 12 17.5114C14.9057 17.5114 16.5343 18.12 16.8686 18.4286C16.5343 18.7372 14.9057 19.3457 12 19.3457Z"
      fill={fill}
    />
  </svg>
);

export const Check = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const Cross = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const Search = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const ChevronDown = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const ChevronUp = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <path d="M18 15l-6-6-6 6" />
  </svg>
);
export const ChevronLeft = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
);
export const ChevronRight = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <path d="M9 18l6-6-6-6" />
  </svg>
);

export const Rotate = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon Icon--rotate"
  >
    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
  </svg>
);

export const Grid = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <rect x="3" y="3" width="7" height="7" fill="#000000" />
    <rect x="14" y="3" width="7" height="7" fill="#000000" />
    <rect x="14" y="14" width="7" height="7" fill="#000000" />
    <rect x="3" y="14" width="7" height="7" fill="#000000" />
  </svg>
);

export const Play = ({ size = 18, fill = "none" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

export const Edit = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="Icon"
  >
    <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34" />
    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
  </svg>
);

export const View = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const Bookmark = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 81 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M63.0926 18.2745C61.7019 16.8838 59.6674 16.1885 56.9632 16.1885H24.7969C22.0928 16.1885 20.0325 16.8838 18.6675 18.2745C17.2768 19.6652 16.5815 21.7255 16.5815 24.4554V61.6437C16.5815 62.6481 16.839 63.4207 17.3283 63.9615C17.8177 64.5024 18.513 64.8114 19.3629 64.8114C19.9552 64.8114 20.5218 64.6311 21.0626 64.2448C21.6034 63.8585 40.6097 48.9214 40.6097 48.9214C40.7642 48.7669 40.9445 48.7669 41.099 48.9214C41.099 48.9214 60.1309 63.8328 60.646 64.2191C61.1611 64.6054 61.7534 64.7857 62.3715 64.7857C63.2471 64.7857 63.9167 64.5024 64.4061 63.9358C64.8954 63.3692 65.1529 62.5966 65.1529 61.618V24.4554C65.1529 21.7255 64.4576 19.6652 63.0669 18.2745H63.0926Z"
      fill="white"
    />
  </svg>
);

export const Close = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_18_3871)">
      <path
        d="M7.79202 21.5669C7.10798 20.8829 7.10798 19.7621 7.80026 19.0698L12.3742 14.4958L7.80026 9.92191C7.11623 9.23788 7.09974 8.11705 7.79202 7.42478C8.48429 6.73251 9.61335 6.74075 10.2974 7.42478L14.8713 11.9987L19.4453 7.42478C20.1293 6.74075 21.2501 6.74075 21.9342 7.42478C22.6264 8.11705 22.6264 9.23788 21.9424 9.92191L17.3684 14.4958L21.9424 19.0698C22.6264 19.7538 22.6347 20.8829 21.9424 21.5752C21.2501 22.2674 20.1293 22.2509 19.4453 21.5669L14.8713 16.993L10.2974 21.5669C9.60511 22.2592 8.48429 22.2592 7.79202 21.5669Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_18_3871">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0.867188 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Plan = ({ size = 18, className = "", fill = "white" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 81 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M63.7814 20.8429C63.7528 20.8429 63.6386 20.8143 63.4671 20.7857C63.41 20.7857 63.3528 20.7857 63.2671 20.7571C63.0671 20.7286 62.7814 20.6714 62.4671 20.6143C62.41 20.6143 62.3814 20.6143 62.3528 20.6143C61.9814 20.5571 61.5528 20.4714 61.0671 20.4143C60.8957 20.4143 60.7243 20.3571 60.5528 20.3286C60.1243 20.2714 59.6385 20.1857 59.1243 20.1286C59.01 20.1286 58.8957 20.1 58.7814 20.0714C57.7243 19.9286 56.5243 19.7857 55.1814 19.6429V17.1C55.1814 16.6143 55.0671 16.1286 54.8957 15.7C54.81 15.5286 54.6957 15.3857 54.5814 15.2429C54.4385 15.0143 54.3243 14.7571 54.1243 14.5571C53.9243 14.3571 53.6671 14.2143 53.41 14.0714C53.2671 13.9857 53.1528 13.8429 52.9814 13.7857C52.6957 13.6714 52.3814 13.6429 52.0671 13.5857C51.8957 13.5857 51.7528 13.5 51.5814 13.5C51.41 13.5 51.2671 13.5857 51.0957 13.5857C50.7814 13.6429 50.4671 13.6429 50.1814 13.7857C50.01 13.8429 49.8957 13.9857 49.7528 14.0714C49.4957 14.2143 49.2385 14.3571 49.0385 14.5571C48.8385 14.7571 48.7243 15.0143 48.5814 15.2429C48.4957 15.4143 48.3528 15.5286 48.2671 15.7C48.0957 16.1286 47.9814 16.6143 47.9814 17.1V19.1C46.8385 19.0429 45.61 19.0143 44.3814 18.9857C43.21 18.9286 42.01 18.9571 40.7814 18.9571C39.5528 18.9571 38.3528 18.9571 37.1814 18.9571C35.9243 18.9857 34.7243 19.0429 33.5814 19.1V17.1C33.5814 16.6143 33.4671 16.1286 33.2957 15.7C33.2385 15.5286 33.0957 15.4143 33.01 15.2714C32.8671 15.0143 32.7243 14.7571 32.5243 14.5571C32.3243 14.3571 32.0671 14.2429 31.8385 14.0714C31.6957 13.9857 31.5528 13.8429 31.41 13.7857C31.1243 13.6714 30.81 13.6429 30.4957 13.5857C30.3243 13.5857 30.1814 13.5 30.01 13.5C29.8385 13.5 29.6957 13.5857 29.5243 13.5857C29.21 13.6429 28.8957 13.6429 28.61 13.7857C28.4385 13.8429 28.3243 13.9857 28.1814 14.0714C27.9243 14.2143 27.6671 14.3571 27.4671 14.5571C27.2671 14.7571 27.1528 15.0143 27.01 15.2429C26.9243 15.4143 26.7814 15.5286 26.6957 15.7C26.5243 16.1286 26.41 16.6143 26.41 17.1V19.6429C25.0671 19.7857 23.8671 19.9286 22.81 20.0714C22.81 20.0714 22.5814 20.1 22.4671 20.1286C21.9528 20.1857 21.4671 20.2714 21.0385 20.3286C20.8671 20.3286 20.6957 20.3857 20.5243 20.4143C20.0385 20.5 19.61 20.5571 19.2385 20.6143C19.1814 20.6143 19.1528 20.6143 19.1243 20.6143C18.7814 20.6714 18.5243 20.7286 18.3243 20.7571C18.2385 20.7571 18.1814 20.7571 18.1243 20.7857C17.9528 20.8143 17.8385 20.8429 17.81 20.8429C16.5528 21.1 15.6385 22.2143 15.6385 23.5L15.6385 62.8429C15.6385 64.1286 16.5243 65.2143 17.7814 65.4714C18.1528 65.5571 27.3243 67.5 40.8671 67.5C54.41 67.5 63.5814 65.5571 63.9528 65.4714C65.21 65.2143 66.0957 64.1 66.0957 62.8429V23.4714C66.0957 22.1857 65.1814 21.0714 63.9243 20.8143L63.7814 20.8429ZM27.3528 56.2143C24.61 56.2143 22.3814 53.9857 22.3814 51.2429C22.3814 48.5 24.61 46.2714 27.3528 46.2714C30.0957 46.2714 32.3243 48.5 32.3243 51.2429C32.3243 53.9857 30.0957 56.2143 27.3528 56.2143ZM27.3528 42.7571C24.61 42.7571 22.3814 40.5286 22.3814 37.7857C22.3814 35.0429 24.61 32.8143 27.3528 32.8143C30.0957 32.8143 32.3243 35.0429 32.3243 37.7857C32.3243 40.5286 30.0957 42.7571 27.3528 42.7571ZM40.7243 56.2143C37.9814 56.2143 35.7528 53.9857 35.7528 51.2429C35.7528 48.5 37.9814 46.2714 40.7243 46.2714C43.4671 46.2714 45.6957 48.5 45.6957 51.2429C45.6957 53.9857 43.4671 56.2143 40.7243 56.2143ZM40.7243 42.7571C37.9814 42.7571 35.7528 40.5286 35.7528 37.7857C35.7528 35.0429 37.9814 32.8143 40.7243 32.8143C43.4671 32.8143 45.6957 35.0429 45.6957 37.7857C45.6957 40.5286 43.4671 42.7571 40.7243 42.7571ZM54.0957 56.2143C51.3528 56.2143 49.1243 53.9857 49.1243 51.2429C49.1243 48.5 51.3528 46.2714 54.0957 46.2714C56.8385 46.2714 59.0671 48.5 59.0671 51.2429C59.0671 53.9857 56.8385 56.2143 54.0957 56.2143ZM54.0957 42.7571C51.3528 42.7571 49.1243 40.5286 49.1243 37.7857C49.1243 35.0429 51.3528 32.8143 54.0957 32.8143C56.8385 32.8143 59.0671 35.0429 59.0671 37.7857C59.0671 40.5286 56.8385 42.7571 54.0957 42.7571Z"
      fill={fill}
    />
  </svg>
);

export const Collection = ({ size = 18, fill = "white" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.63162 11.7996L7.19139 18.1979C6.27994 18.0625 5.62896 17.4023 5.33106 16.3072L3.68451 10.154C3.26879 8.60624 3.93062 7.45316 5.48481 7.03688L14.0137 4.75223C15.5679 4.33595 16.7145 4.99834 17.1303 6.54606L17.2754 7.08747L10.0621 7.71856C7.78483 7.91779 6.43295 9.52889 6.63162 11.7996ZM11.1674 20.3533C9.56304 20.4936 8.54347 19.6441 8.40311 18.0397L7.84786 11.6932C7.70806 10.0953 8.56405 9.07517 10.1685 8.9348L18.9604 8.16561C20.5648 8.02524 21.5849 8.88123 21.7247 10.4792L22.2799 16.8256C22.4203 18.43 21.5637 19.4437 19.9593 19.5841L11.1674 20.3533Z"
      fill={fill}
    />
  </svg>
);

export const PadLock = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 74 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57.1347 32.4479H53.5538V25.5374C53.5538 16.3444 46.1408 9.01505 36.9477 9.01505C27.7546 9.01505 20.2578 16.3234 20.2578 25.5374V32.4479H16.8863C15.0435 32.4479 13.5358 34.0394 13.5358 35.8822V59.2104C13.5358 60.8438 14.7085 62.2259 16.3209 62.5191C23.1267 63.7127 30.1 63.9849 37.0105 63.9849C43.921 63.9849 50.8943 63.7127 57.7001 62.5191C59.3126 62.2468 60.4643 60.8438 60.4643 59.2104V35.8822C60.4643 34.0394 58.9775 32.4479 57.1138 32.4479H57.1347ZM28.6342 25.5374C28.6342 20.9514 32.4454 17.182 37.0105 17.182C41.5756 17.182 45.4288 20.9304 45.4288 25.5165V32.4479H28.6132V25.5374H28.6342Z"
      fill="currentColor"
    />
  </svg>
);

export default {
  ArrowRight,
  Bookmark,
  ChefHat,
  Check,
  Close,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Cross,
  Grid,
  Rotate,
  View,
  Search,
  Time,
  Minus,
  Plan,
  PadLock,
};
